import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';
import { PaletteColor } from '@utils/types';

export const BookerHr = styled.hr`
  width: 100%;
  border-top: unset;
  margin: 0 auto;
  border: 0;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    width: 90%;
    border: 0;
    border-top: 1px solid rgba(41, 42, 44, 0.15);
  }
`;

export const ClearSearchButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 3;
  display: flex;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    background-color: rgb(232, 182, 90, 0.1);
  }
`;

export const ListItemContent = styled.div`
  cursor: pointer;
  flex: 1;
  z-index: 99999;

  path {
    fill: inherit !important;
  }
`;

export const ItemText = styled.div`
  padding-left: 15px;
  flex: 1;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  align-items: end;
  margin-bottom: 10px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 17px 0 0 20px;
    align-items: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

export const Text = styled.span<{ color: PaletteColor }>`
  color: ${({ theme, color }) => theme.palette[color]};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding-left: 4px;

  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding-left: 17px;
  }
`;

export const BookerSearchInputWrapper = styled.div<{ height?: number }>`
  height: 300px !important;
  overflow: auto !important;
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.palette.gray};
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.brownishGrey};
    border-radius: 10px;
  }
  .react-tiny-popover-container {
    width: 570px !important;
    top: -25px !important;
  }
  .setur-list {
    &.setur-list-bordered {
      border: none;
    }
  }
`;

export const HotelSeachWrapper = styled.div`
  .react-tiny-popover-container {
    width: 570px !important;
    top: -25px !important;
  }
`;

export const ResponsiveListingSearchLocationContainer = styled.div`
  padding: 24px 15px 12px 15px;
  background: ${({ theme }) => theme.palette.white};
  cursor: pointer;
`;

export const GuestWrapper = styled.div`
  width: 570px;
  height: 200px;
  position: absolute;
  z-index: 10;
  background: ${({ theme }) => theme.palette.white};
`;

export const GuestContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 20px 15px 20px;
  position: absolute;
  background: ${({ theme }) => theme.palette.white};
`;

export const ResponsiveSearchDrawerItemContainer = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-bottom: solid 1px rgba(41, 42, 44, 0.15);
  position: relative;
`;

export const ResponsiveListingSearchContainer = styled.div`
  padding: 0px 15px 24px 15px;
  background: ${({ theme }) => theme.palette.white};
  cursor: pointer;
`;

export const AddRoomWrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'unset')};
  cursor: pointer;
`;

export const ResponsiveSearchDrawerItemWrapper = styled.div`
  padding: 0 18px;
`;

export const ButtonsWrapper = styled.div`
  height: 70px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.white};
  align-items: center;
  padding: 0 20px;
  position: absolute;
  bottom: 0;
  z-index: 10;
  width: 100%;
  box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
`;

export const AddRoomText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  padding-bottom: 5px;
`;

export const ItemErrorText = styled(ItemText)`
  color: rgb(226, 35, 27);
  font-size: 14px;
  padding: 1rem;
`;
